// extracted by mini-css-extract-plugin
export default {"payItem":"button_payItem__ZieM4"};